import { render, staticRenderFns } from "./transitionForm.vue?vue&type=template&id=b841f7c2&lang=pug&"
import script from "./transitionForm.vue?vue&type=script&lang=js&"
export * from "./transitionForm.vue?vue&type=script&lang=js&"
import style0 from "./transitionForm.vue?vue&type=style&index=0&id=b841f7c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports